import React, { useState } from 'react'
import { urls } from '@chilipiper/config'
import { Box, Flex, Text } from '@chilipiper/design-system'
import { Popover, UnstyledButton, Icon } from '@chilipiper/design-system/src/new'
import {
  IconHelp,
  IconChevronRight,
  IconNewTab,
  IconChilihub,
  IconCompass,
  IconQuestionMarkCircle,
  IconSend,
} from '@chilipiper/icons/figma-generated/src/icon'
import { NavItem } from './NavItem'
import { StyledHoverButton } from './personal-settings-menu/styled'

const CHILI_HUB_URL =
  'https://help.chilipiper.com/hc/en-us/categories/29182155306259-Demand-Conversion-Platform'

const supportLinks = [
  { label: 'Help Center', icon: IconQuestionMarkCircle, href: urls.help },
  { label: 'Chili Hub', icon: IconChilihub, href: CHILI_HUB_URL },
  { label: 'Chili Piper University', icon: IconCompass, href: urls.university },
  { label: 'Suggest a Feature', icon: IconSend, href: urls.suggest },
]

type Props = {
  isExpanded: boolean
}

export const SupportSection = ({ isExpanded }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Popover
      placement='top start'
      offset={-8}
      crossOffset={112}
      onOpenChange={setIsOpen}
      isOpen={isOpen}
      trigger={triggerProps => (
        <UnstyledButton ariaProps={triggerProps} aria-label='Open support menu'>
          <NavItem
            isExpanded={isExpanded}
            icon={IconHelp}
            label='Support'
            rightIcon={IconChevronRight}
          />
        </UnstyledButton>
      )}
    >
      <Box borderRadius={8} boxShadow='border/popover'>
        <Box borderRadius={8} overflow='hidden' w='250px' bg='bg/minor' as='ul'>
          {supportLinks.map(({ label, icon, href }) => (
            <StyledHoverButton key={label} as='li'>
              <Flex
                as='a'
                href={href}
                target='_blank'
                rel='noreferrer'
                onClick={() => setIsOpen(false)}
                px={4}
                py={3}
                alignItems='center'
                justifyContent='space-between'
              >
                <Flex alignItems='center'>
                  <Icon icon={icon} mr={3} color='fg/moderate' />
                  <Text textStyle='item-unselected' color='fg/major'>
                    {label}
                  </Text>
                </Flex>
                <Icon icon={IconNewTab} color='fg/moderate' />
              </Flex>
            </StyledHoverButton>
          ))}
        </Box>
      </Box>
    </Popover>
  )
}
